<template>
	<div class="widget footer-about">
		<img src="@/assets/img/logo.png" alt="Ius Populi" class="img-responsive margin-bottom-30 footer-logo" />
		<p>
			{{ $t('Sentence.FooterSiteInfo') }}
			<router-link :to="{ name: 'about' }" class="info-link">{{ $t('Link.ReadMore') }}</router-link>
		</p>
	</div>
</template>

<script>
export default {
	name: 'FooterSiteInfo',
}
</script>



// WEBPACK FOOTER //
// src/components/footer/FooterSiteInfo.vue